<template>
  <div>
    <modal
      ref="modal"
      :showing="showing"
      :show-close="showClose"
      :background-close="backgroundClose"
      @close="close"
    >
      <div class="bg-grayVeryLight relative mx-auto lg:mx-0 p-24 lg:p-64 text-black">
        <div class="grid grid-cols-12 gap-24 text-center">
          <h1 class="h1 col-span-12">
            {{ $t('title') }}
          </h1>
          <div class="col-start-1 col-span-12 mb-16 text-gray text-left">
            <p v-if="[language, primaryLanguage, browserLanguage].includes('de')" class="mb-8 lg:mb-12">
              Die aktuelle Sprache der Webseite ist "{{ getLanguageName($root.$i18n.locale, 'de') }}". Möchten Sie in dieser Sprachversion bleiben oder zu einer anderen wechseln?
            </p>
            <p class="mb-8 lg:mb-12">
              The current language of the website is "{{ getLanguageName($root.$i18n.locale, 'en') }}". Would you like to remain on this language version or switch to another one?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('el')" class="mb-8 lg:mb-12">
              Η τρέχουσα γλώσσα του ιστότοπου είναι "{{ getLanguageName($root.$i18n.locale, 'el') }}". Θέλετε να παραμείνετε σε αυτήν την έκδοση γλώσσας ή να αλλάξετε σε άλλη;
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('es')" class="mb-8 lg:mb-12">
              El idioma actual del sitio web es "{{ getLanguageName($root.$i18n.locale, 'es') }}". ¿Desea permanecer en esta versión de idioma o cambiar a otra?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('fr')" class="mb-8 lg:mb-12">
              La langue actuelle du site web est "{{ getLanguageName($root.$i18n.locale, 'fr') }}". Souhaitez-vous rester dans cette version linguistique ou en changer?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('it')" class="mb-8 lg:mb-12">
              La lingua attuale del sito web è "{{ getLanguageName($root.$i18n.locale, 'it') }}". Vorresti rimanere in questa versione linguistica o passare a un'altra?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('nl')" class="mb-8 lg:mb-12">
              De huidige taal van de website is "{{ getLanguageName($root.$i18n.locale, 'nl') }}". Wilt u op deze taalversie blijven of naar een andere overschakelen?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('pl')" class="mb-8 lg:mb-12">
              Aktualny język strony to "{{ getLanguageName($root.$i18n.locale, 'pl') }}". Czy chcesz pozostać w tej wersji językowej, czy przełączyć na inną?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('pt')" class="mb-8 lg:mb-12">
              A linguagem atual do site é "{{ getLanguageName($root.$i18n.locale, 'pt') }}". Gostaria de permanecer nesta versão do idioma ou mudar para outra?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('ru')" class="mb-8 lg:mb-12">
              Текущий язык сайта - "{{ getLanguageName($root.$i18n.locale, 'ru') }}". Хотите остаться на этой языковой версии или переключиться на другую?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('cs')" class="mb-8 lg:mb-12">
              Aktuální jazyk webu je "{{ getLanguageName($root.$i18n.locale, 'cs') }}". Chcete zůstat v této jazykové verzi nebo přepnout na jinou?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('fi')" class="mb-8 lg:mb-12">
              Nykyinen verkkosivuston kieli on "{{ getLanguageName($root.$i18n.locale, 'fi') }}". Haluatko pysyä tässä kieliversiossa vai vaihtaa toiseen?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('hu')" class="mb-8 lg:mb-12">
              A weboldal jelenlegi nyelve "{{ getLanguageName($root.$i18n.locale, 'hu') }}". Szeretne ezen a nyelvi verzión maradni, vagy váltani egy másikra?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('ja')" class="mb-8 lg:mb-12">
              現在のウェブサイトの言語は "{{ getLanguageName($root.$i18n.locale, 'ja') }}" です。この言語バージョンのままにしますか、それとも別の言語に変更しますか？
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('ro')" class="mb-8 lg:mb-12">
              Limba actuală a site-ului este "{{ getLanguageName($root.$i18n.locale, 'ro') }}". Doriți să rămâneți pe această versiune lingvistică sau să treceți la alta?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('sk')" class="mb-8 lg:mb-12">
              Aktuálny jazyk webu je "{{ getLanguageName($root.$i18n.locale, 'sk') }}". Chcete zostať v tejto jazykovej verzii alebo prepnúť na inú?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('sl')" class="mb-8 lg:mb-12">
              Trenutni jezik spletne strani je "{{ getLanguageName($root.$i18n.locale, 'sl') }}". Želite ostati na tej jezikovni različici ali preklopiti na drugo?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('sv')" class="mb-8 lg:mb-12">
              Det aktuella språket på webbplatsen är "{{ getLanguageName($root.$i18n.locale, 'sv') }}". Vill du stanna kvar på denna språkversion eller byta till en annan?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('zh')" class="mb-8 lg:mb-12">
              当前网站语言为 "{{ getLanguageName($root.$i18n.locale, 'zh') }}"。您想继续使用此语言版本还是切换到其他版本？
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('ar')" class="mb-8 lg:mb-12 rtl text-right">
              اللغة الحالية للموقع هي "{{ getLanguageName($root.$i18n.locale, 'ar') }}". هل ترغب في البقاء في هذا الإصدار اللغوي أم تغيير إلى آخر؟
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('he')" class="mb-8 lg:mb-12 rtl text-right">
              השפה הנוכחית של האתר היא "{{ getLanguageName($root.$i18n.locale, 'he') }}". האם אתה רוצה להישאר בגרסה זו של השפה או לעבור לאחרת?
            </p>
            <p v-if="[language, primaryLanguage, browserLanguage].includes('uk')" class="mb-8 lg:mb-12 rtl text-right">
              Поточна мова сайту - "{{ getLanguageName($root.$i18n.locale, 'uk') }}". Хочете залишитися на цій мовній версії або перейти на іншу?
            </p>
          </div>
          <div class="col-start-1 col-span-12 md:col-start-4 md:col-span-6 mb-16">
            <input-select v-model="$root.$i18n.locale"
                          name="language"
                          :values="languageOptions"
                          :label="$t('languageModal.language')"
                          :placeholder="$t('languageModal.languagePlaceholder')"
                          :optional="false"
            />
            <!--            <select v-model="$root.$i18n.locale" type="select" class="language-switcher language-switcher&#45;&#45;large col-span-1">-->
            <!--              <option v-for="lang in (isEmpty(languages) ? [primaryLanguage || 'de', 'en'] : languages)" :key="lang" :value="lang">-->
            <!--                {{ getLanguageName(lang, lang) }}-->
            <!--              </option>-->
            <!--            </select>-->
          </div>
          <button-big class="col-start-1 col-span-12" @click="confirmAndClose">
            <span class="text-16 text-white font-medium">
              {{ $t('confirmLanguageSelection') }}
            </span>
          </button-big>
          <div class="text-gray mt-16 col-start-1 col-span-12 text-body-small hidden lg:block mb-84">
            <p class="mb-8">
              {{ $t('languageSwitchDesktop') }}
            </p>
            <p v-if="language !== 'en'" class="mb-8">
              {{ $t('languageSwitchDesktop', 'en') }}
            </p>
          </div>
          <div class="text-gray mt-16 col-start-1 col-span-12 text-body-small lg:hidden mb-84">
            <p class="mb-8">
              {{ $t('languageSwitchMobile') }}
            </p>
            <p v-if="language !== 'en'" class="mb-8">
              {{ $t('languageSwitchMobile', 'en') }}
            </p>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { XIcon } from 'vue-feather-icons';
import Modal from './Modal';
import ButtonBig from '../ButtonBig/ButtonBig';
import { isEmpty, isNil } from 'lodash/lang';
import InputSelect from '@/components/lib/InputElements/InputSelect/InputSelect.vue';

export default {
  name: 'LanguageModal',

  components: {
    InputSelect,
    XIcon,
    Modal,
    ButtonBig,
  },

  props: {
    // showing: {
    //   required: true,
    //   type: Boolean,
    // },
    showClose: {
      type: Boolean,
      default: true,
    },
    backgroundClose: {
      type: Boolean,
      default: true,
    },
    languages: {
      type: Array,
      default: () => ['de', 'en'],
      required: false,
    },
  },

  data: function () {
    return {
      showing: false,
      browserLanguage: null,
    };
  },

  computed: {
    hotel() {
      return this.$store.getters.hotel;
    },
    primaryLanguage() {
      if (!isNil(this.hotel) && !isNil(this.hotel.details)) return this.hotel.details.primaryLanguage;
      else return null;
    },
    language() {
      if (isNil(this.$root)) return null;
      return this.$root.$i18n.locale;
    },
    languageOptions() {
      return (this.languages || ['de', 'en'])
        .map((it) => ({
          code: it,
          label: this.getLanguageName(it, it),
        }));
    },
  },

  watch: {
    showing(value) {
      if (value) {
        return document.querySelector('body')
          .classList
          .add('overflow-hidden');
      }
      return document.querySelector('body')
        .classList
        .remove('overflow-hidden');
    },
  },

  created() {
    this.$serviceBus.$on('shortcut.esc', this.close);
    this.$serviceBus.$on('languageModal.show', () => { this.showing = true; });
    this.$serviceBus.$on('languageModal.hide', () => {
      this.showing = false;
      // this.close();
    });

    let browserLanguage = navigator.language || navigator.userLanguage;
    if (!isEmpty(browserLanguage)) {
      browserLanguage = browserLanguage.substring(0, 2);
    }

    this.browserLanguage = browserLanguage || null;
  },

  beforeDestroy() {
    this.$serviceBus.$off('shortcut.esc', this.close);
    this.$serviceBus.$off('languageModal.show');
    this.$serviceBus.$off('languageModal.hide');

    return document.querySelector('body')
      .classList
      .remove('overflow-hidden');
  },

  methods: {
    isEmpty,
    close() {
      this.$serviceBus.$emit('languageModal.hide');
      // this.$refs.modal.close();
    },
    getLanguageName(lang, targetLang = null) {
      const ret = this.$t(lang, targetLang || lang);
      if (!isEmpty(ret) && ret.length > 2) return ret;
      switch (lang) {
        case 'de': return 'Deutsch';
        case 'en': return 'English';
        case 'es': return 'Español';
        case 'fr': return 'Français';
        case 'it': return 'Italiano';
        case 'nl': return 'Nederlands';
        case 'pl': return 'Polski';
        case 'pt': return 'Português';
        case 'ru': return 'Русский язык';
        case 'el': return 'Ελληνικά';
        case 'fi': return 'Suomi';
        case 'cs': return 'Čeština';
        case 'ja': return '日本語';
        case 'ro': return 'Română';
        case 'sk': return 'Slovenčina';
        case 'sl': return 'Slovenščina';
        case 'sv': return 'Svenska';
        case 'zh': return '中文';
        default: return lang;
      }
    },
    confirmAndClose() {
      this.$serviceBus.$emit('languageModal.confirm', this.$root.$i18n.locale);
      this.close();
    },
  },

  i18n: {
    messages: {
      de: {
        title: 'Sprachauswahl',
        languageSwitchDesktop: 'Die Auswahl der Sprache kann jederzeit, auch später, in der linken unteren Ecke geändert werden',
        languageSwitchMobile: 'Die Auswahl der Sprache kann jederzeit, auch später, im Menü (zum Öffnen in die recht obere Ecke klicken) geändert werden.',
        confirmLanguageSelection: 'Sprachauswahl bestätigen',
        de: 'Deutsch',
        en: 'Englisch',
        es: 'Spanisch',
        fr: 'Französisch',
        it: 'Italienisch',
        nl: 'Niederländisch',
        pl: 'Polnisch',
        pt: 'Portugiesisch',
        ru: 'Russisch',
        el: 'Griechisch',
        'fi': 'Finnisch',
        'hu': 'Ungarisch',
        'ja': 'Japanisch',
        'ro': 'Rumänisch',
        'sk': 'Slowakisch',
        'sl': 'Slowenisch',
        'sv': 'Schwedisch',
        'zh': 'Chinesisch',
        'he': 'Hebräisch',
        'ar': 'Arabisch',
      },
      en: {
        title: 'Language selection',
        languageSwitchDesktop: 'The language selection can be changed at any time, even later, in the lower left corner',
        languageSwitchMobile: 'The language selection can be changed at any time, even later, in the menu (click in the upper right corner to open it).',
        confirmLanguageSelection: 'Confirm language selection',
        de: 'German',
        en: 'English',
        es: 'Spanish',
        fr: 'French',
        it: 'Italian',
        nl: 'Dutch',
        pl: 'Polish',
        pt: 'Portuguese',
        ru: 'Russian',
        el: 'Greek',
        'fi': 'Finnish',
        'hu': 'Hungarian',
        'ja': 'Japanese',
        'ro': 'Romanian',
        'sk': 'Slovak',
        'sl': 'Slovenian',
        'sv': 'Swedish',
        'zh': 'Chinese',
        'he': 'Hebrew',
        'ar': 'Arabic',
      },
      ar: {
        title: 'اختيار اللغة',
        languageSwitchDesktop: 'يمكن تغيير اختيار اللغة في أي وقت، حتى لاحقًا، في الزاوية السفلية اليسرى',
        languageSwitchMobile: 'يمكن تغيير اختيار اللغة في أي وقت، حتى لاحقًا، في القائمة (انقر في الزاوية اليمنى العليا لفتحها).',
        confirmLanguageSelection: 'تأكيد اختيار اللغة',
        de: 'ألمانية',
        en: 'الإنجليزية',
        es: 'الإسبانية',
        fr: 'الفرنسية',
        it: 'الإيطالية',
        nl: 'الهولندية',
        pl: 'البولندية',
        pt: 'البرتغالية',
        ru: 'الروسية',
        el: 'اليونانية',
        'fi': 'الفنلندية',
        'hu': 'المجرية',
        'ja': 'اليابانية',
        'ro': 'الرومانية',
        'sk': 'السلوفاكية',
        'sl': 'السلوفينية',
        'sv': 'السويدية',
        'zh': 'الصينية',
        'he': 'العبرية',
        'ar': 'العربية',
      },
      el: {
        title: 'Επιλογή γλώσσας',
        languageSwitchDesktop: 'Η επιλογή γλώσσας μπορεί να αλλάξει ανά πάσα στιγμή, ακόμη και αργότερα, στην κάτω αριστερή γωνία',
        languageSwitchMobile: 'Η επιλογή γλώσσας μπορεί να αλλάξει ανά πάσα στιγμή, ακόμη και αργότερα, από το μενού (κάντε κλικ στην επάνω δεξιά γωνία για να το ανοίξετε).',
        confirmLanguageSelection: 'Επιβεβαίωση επιλογής γλώσσας',
        de: 'Γερμανικά',
        en: 'Αγγλικά',
        es: 'Ισπανικά',
        fr: 'Γαλλικά',
        it: 'Ιταλικά',
        nl: 'Ολλανδικά',
        pl: 'Πολωνικά',
        pt: 'Πορτογαλικά',
        ru: 'Ρωσικά',
        el: 'Ελληνικά',
        'fi': 'Φινλανδικά',
        'hu': 'Ουγγρικά',
        'ja': 'Ιαπωνικά',
        'ro': 'Ρουμανικά',
        'sk': 'Σλοβακικά',
        'sl': 'Σλοβενικά',
        'sv': 'Σουηδικά',
        'zh': 'Κινέζικα',
        'he': 'Εβραϊκά',
        'ar': 'Αραβικά',
      },
      es: {
        title: 'Selección de idioma',
        languageSwitchDesktop: 'La selección del idioma se puede cambiar en cualquier momento, incluso más tarde, en la esquina inferior izquierda',
        languageSwitchMobile: 'La selección del idioma se puede cambiar en cualquier momento, incluso más tarde, en el menú (haga clic en la esquina superior derecha para abrirlo).',
        confirmLanguageSelection: 'Confirmar selección de idioma',
        de: 'Alemán',
        en: 'Inglés',
        es: 'Español',
        fr: 'Francés',
        it: 'Italiano',
        nl: 'Holandés',
        pl: 'Polaco',
        pt: 'Portugués',
        ru: 'Ruso',
        el: 'Griego',
        'fi': 'Finlandés',
        'hu': 'Húngaro',
        'ja': 'Japonés',
        'ro': 'Rumano',
        'sk': 'Eslovaco',
        'sl': 'Esloveno',
        'sv': 'Sueco',
        'zh': 'Chino',
        'he': 'Hebreo',
        'ar': 'Árabe',
      },
      fr: {
        title: 'Sélection de la langue',
        languageSwitchDesktop: 'La sélection de la langue peut être modifiée à tout moment, même plus tard, dans le coin inférieur gauche',
        languageSwitchMobile: 'La sélection de la langue peut être modifiée à tout moment, même plus tard, dans le menu (cliquez dans le coin supérieur droit pour l\'ouvrir).',
        confirmLanguageSelection: 'Confirmer la sélection de la langue',
        de: 'Allemand',
        en: 'Anglais',
        es: 'Espagnol',
        fr: 'Français',
        it: 'Italien',
        nl: 'Néerlandais',
        pl: 'Polonais',
        pt: 'Portugais',
        ru: 'Russe',
        el: 'Grec',
        'fi': 'Finnois',
        'hu': 'Hongrois',
        'ja': 'Japonais',
        'ro': 'Roumain',
        'sk': 'Slovaque',
        'sl': 'Slovène',
        'sv': 'Suédois',
        'zh': 'Chinois',
        'he': 'Hébreu',
        'ar': 'Arabe',
      },
      he: {
        title: 'בחירת שפה',
        languageSwitchDesktop: 'ניתן לשנות את בחירת השפה בכל עת, גם מאוחר יותר, בפינה השמאלית התחתונה',
        languageSwitchMobile: 'ניתן לשנות את בחירת השפה בכל עת, גם מאוחר יותר, בתפריט (לחץ בפינה הימנית העליונה כדי לפתוח).',
        confirmLanguageSelection: 'אשר את בחירת השפה',
        de: 'גרמנית',
        en: 'אנגלית',
        es: 'ספרדית',
        fr: 'צרפתית',
        it: 'איטלקית',
        nl: 'הולנדית',
        pl: 'פולנית',
        pt: 'פורטוגזית',
        ru: 'רוסית',
        el: 'יוונית',
        'fi': 'פינית',
        'hu': 'הונגרית',
        'ja': 'יפנית',
        'ro': 'רומנית',
        'sk': 'סלובקית',
        'sl': 'סלובנית',
        'sv': 'שוודית',
        'zh': 'סינית',
        'he': 'עברית',
        'ar': 'ערבית',
      },
      it: {
        title: 'Selezione della lingua',
        languageSwitchDesktop: 'La selezione della lingua può essere modificata in qualsiasi momento, anche successivamente, nell\'angolo in basso a sinistra',
        languageSwitchMobile: 'La selezione della lingua può essere modificata in qualsiasi momento, anche successivamente, nel menu (fai clic nell\'angolo in alto a destra per aprirlo).',
        confirmLanguageSelection: 'Conferma selezione della lingua',
        de: 'Tedesco',
        en: 'Inglese',
        es: 'Spagnolo',
        fr: 'Francese',
        it: 'Italiano',
        nl: 'Olandese',
        pl: 'Polacco',
        pt: 'Portoghese',
        ru: 'Russo',
        el: 'Greco',
        'fi': 'Finlandese',
        'hu': 'Ungherese',
        'ja': 'Giapponese',
        'ro': 'Rumeno',
        'sk': 'Slovacco',
        'sl': 'Sloveno',
        'sv': 'Svedese',
        'zh': 'Cinese',
        'he': 'Ebraico',
        'ar': 'Arabo',
      },
      nl: {
        title: 'Taalkeuze',
        languageSwitchDesktop: 'De taalkeuze kan op elk moment worden gewijzigd, ook later, in de linkerbenedenhoek',
        languageSwitchMobile: 'De taalkeuze kan op elk moment worden gewijzigd, ook later, in het menu (klik in de rechterbovenhoek om het te openen).',
        confirmLanguageSelection: 'Bevestig taalkeuze',
        de: 'Duits',
        en: 'Engels',
        es: 'Spaans',
        fr: 'Frans',
        it: 'Italiaans',
        nl: 'Nederlands',
        pl: 'Pools',
        pt: 'Portugees',
        ru: 'Russisch',
        el: 'Grieks',
        'fi': 'Fins',
        'hu': 'Hongaars',
        'ja': 'Japans',
        'ro': 'Roemeens',
        'sk': 'Slowaaks',
        'sl': 'Sloveens',
        'sv': 'Zweeds',
        'zh': 'Chinees',
        'he': 'Hebreeuws',
        'ar': 'Arabisch',
      },
      pl: {
        title: 'Wybór języka',
        languageSwitchDesktop: 'Wybór języka można zmienić w dowolnym momencie, nawet później, w lewym dolnym rogu',
        languageSwitchMobile: 'Wybór języka można zmienić w dowolnym momencie, nawet później, w menu (kliknij w prawym górnym rogu, aby otworzyć).',
        confirmLanguageSelection: 'Potwierdź wybór języka',
        de: 'Niemiecki',
        en: 'Angielski',
        es: 'Hiszpański',
        fr: 'Francuski',
        it: 'Włoski',
        nl: 'Holenderski',
        pl: 'Polski',
        pt: 'Portugalski',
        ru: 'Rosyjski',
        el: 'Grecki',
        'fi': 'Fiński',
        'hu': 'Węgierski',
        'ja': 'Japoński',
        'ro': 'Rumuński',
        'sk': 'Słowacki',
        'sl': 'Słoweński',
        'sv': 'Szwedzki',
        'zh': 'Chiński',
        'he': 'Hebrajski',
        'ar': 'Arabski',
      },
      pt: {
        title: 'Seleção de idioma',
        languageSwitchDesktop: 'A seleção do idioma pode ser alterada a qualquer momento, mesmo mais tarde, no canto inferior esquerdo',
        languageSwitchMobile: 'A seleção do idioma pode ser alterada a qualquer momento, mesmo mais tarde, no menu (clique no canto superior direito para abri-lo).',
        confirmLanguageSelection: 'Confirmar seleção de idioma',
        de: 'Alemão',
        en: 'Inglês',
        es: 'Espanhol',
        fr: 'Francês',
        it: 'Italiano',
        nl: 'Holandês',
        pl: 'Polonês',
        pt: 'Português',
        ru: 'Russo',
        el: 'Grego',
        'fi': 'Finlandês',
        'hu': 'Húngaro',
        'ja': 'Japonês',
        'ro': 'Romeno',
        'sk': 'Eslovaco',
        'sl': 'Esloveno',
        'sv': 'Sueco',
        'zh': 'Chinês',
        'he': 'Hebraico',
        'ar': 'Árabe',
      },
      ru: {
        title: 'Выбор языка',
        languageSwitchDesktop: 'Выбор языка можно изменить в любое время, даже позже, в нижнем левом углу',
        languageSwitchMobile: 'Выбор языка можно изменить в любое время, даже позже, в меню (щелкните в правом верхнем углу, чтобы открыть его).',
        confirmLanguageSelection: 'Подтвердить выбор языка',
        de: 'Немецкий',
        en: 'Английский',
        es: 'Испанский',
        fr: 'Французский',
        it: 'Итальянский',
        nl: 'Голландский',
        pl: 'Польский',
        pt: 'Португальский',
        ru: 'Русский',
        el: 'Греческий',
        'fi': 'Финский',
        'hu': 'Венгерский',
        'ja': 'Японский',
        'ro': 'Румынский',
        'sk': 'Словацкий',
        'sl': 'Словенский',
        'sv': 'Шведский',
        'zh': 'Китайский',
        'he': 'Иврит',
        'ar': 'Арабский',
      },
      'fi': {
        'title': 'Kielen valinta',
        'languageSwitchDesktop': 'Kielen valinnan voi muuttaa milloin tahansa, myös myöhemmin, vasemmassa alakulmassa',
        'languageSwitchMobile': 'Kielen valinnan voi muuttaa milloin tahansa, myös myöhemmin, valikossa (avaa napsauttamalla oikeaa yläkulmaa).',
        'confirmLanguageSelection': 'Vahvista kielen valinta',
        'cs': 'Tšekki',
        'de': 'Saksa',
        'el': 'Kreikka',
        'en': 'Englanti',
        'es': 'Espanja',
        'fi': 'Suomi',
        'fr': 'Ranska',
        'hu': 'Unkari',
        'it': 'Italia',
        'ja': 'Japani',
        'nl': 'Hollanti',
        'pl': 'Puola',
        'pt': 'Portugali',
        'ro': 'Romania',
        'ru': 'Venäjä',
        'sk': 'Slovakia',
        'sl': 'Sloveeni',
        'sv': 'Ruotsi',
        'zh': 'Kiina',
        'he': 'Heprea',
        'ar': 'Arabia',
      },
      'cs': {
        'title': 'Výběr jazyka',
        'languageSwitchDesktop': 'Výběr jazyka lze kdykoliv změnit, i později, v levém dolním rohu',
        'languageSwitchMobile': 'Výběr jazyka lze kdykoliv změnit, i později, v nabídce (kliknutím do pravého horního rohu jej otevřete).',
        'confirmLanguageSelection': 'Potvrdit výběr jazyka',
        'cs': 'Čeština',
        'de': 'Němčina',
        'el': 'Řečtina',
        'en': 'Angličtina',
        'es': 'Španělština',
        'fi': 'Finština',
        'fr': 'Francouzština',
        'hu': 'Maďarština',
        'it': 'Italština',
        'ja': 'Japonština',
        'nl': 'Nizozemština',
        'pl': 'Polština',
        'pt': 'Portugalština',
        'ro': 'Rumunština',
        'ru': 'Ruština',
        'sk': 'Slovenština',
        'sl': 'Slovinština',
        'sv': 'Švédština',
        'zh': 'Čínština',
        'he': 'Hebrejština',
        'ar': 'Arabština',
      },
      'ja': {
        'title': '言語選択',
        'languageSwitchDesktop': '言語の選択は、いつでも、後からでも、左下隅で変更できます',
        'languageSwitchMobile': '言語の選択は、いつでも、後からでも、メニュー（右上隅をクリックして開く）で変更できます。',
        'confirmLanguageSelection': '言語選択を確認',
        'cs': 'チェコ語',
        'de': 'ドイツ語',
        'el': 'ギリシャ語',
        'en': '英語',
        'es': 'スペイン語',
        'fi': 'フィンランド語',
        'fr': 'フランス語',
        'hu': 'ハンガリー語',
        'it': 'イタリア語',
        'ja': '日本語',
        'nl': 'オランダ語',
        'pl': 'ポーランド語',
        'pt': 'ポルトガル語',
        'ro': 'ルーマニア語',
        'ru': 'ロシア語',
        'sk': 'スロバキア語',
        'sl': 'スロベニア語',
        'sv': 'スウェーデン語',
        'zh': '中国語',
        'he': 'ヘブライ語',
        'ar': 'アラビア語',
      },
      'ro': {
        'title': 'Selectarea limbii',
        'languageSwitchDesktop': 'Selectarea limbii poate fi schimbată oricând, chiar și mai târziu, în colțul din stânga jos',
        'languageSwitchMobile': 'Selectarea limbii poate fi schimbată oricând, chiar și mai târziu, din meniu (faceți clic în colțul din dreapta sus pentru a deschide).',
        'confirmLanguageSelection': 'Confirmă selecția limbii',
        'cs': 'Cehă',
        'de': 'Germană',
        'el': 'Greacă',
        'en': 'Engleză',
        'es': 'Spaniolă',
        'fi': 'Finlandeză',
        'fr': 'Franceză',
        'hu': 'Maghiară',
        'it': 'Italiană',
        'ja': 'Japoneză',
        'nl': 'Olandeză',
        'pl': 'Poloneză',
        'pt': 'Portugheză',
        'ro': 'Română',
        'ru': 'Rusă',
        'sk': 'Slovacă',
        'sl': 'Slovenă',
        'sv': 'Suedeză',
        'zh': 'Chineză',
        'he': 'Ebraică',
        'ar': 'Arabă',
      },
      'sv': {
        'title': 'Språkval',
        'languageSwitchDesktop': 'Språkvalet kan ändras när som helst, även senare, i det nedre vänstra hörnet',
        'languageSwitchMobile': 'Språkvalet kan ändras när som helst, även senare, i menyn (klicka i det övre högra hörnet för att öppna den).',
        'confirmLanguageSelection': 'Bekräfta språkval',
        'cs': 'Tjeckiska',
        'de': 'Tyska',
        'el': 'Grekiska',
        'en': 'Engelska',
        'es': 'Spanska',
        'fi': 'Finska',
        'fr': 'Franska',
        'hu': 'Ungerska',
        'it': 'Italienska',
        'ja': 'Japanska',
        'nl': 'Nederländska',
        'pl': 'Polska',
        'pt': 'Portugisiska',
        'ro': 'Rumänska',
        'ru': 'Ryska',
        'sk': 'Slovakiska',
        'sl': 'Slovenska',
        'sv': 'Svenska',
        'zh': 'Kinesiska',
        'he': 'Hebreiska',
        'ar': 'Arabiska',
      },
      'zh': {
        'title': '语言选择',
        'languageSwitchDesktop': '可以随时更改语言选择，即使稍后，在左下角',
        'languageSwitchMobile': '可以随时更改语言选择，即使稍后，在菜单中（点击右上角打开）。',
        'confirmLanguageSelection': '确认语言选择',
        'cs': '捷克语',
        'de': '德语',
        'el': '希腊语',
        'en': '英语',
        'es': '西班牙语',
        'fi': '芬兰语',
        'fr': '法语',
        'hu': '匈牙利语',
        'it': '意大利语',
        'ja': '日语',
        'nl': '荷兰语',
        'pl': '波兰语',
        'pt': '葡萄牙语',
        'ro': '罗马尼亚语',
        'ru': '俄语',
        'sk': '斯洛伐克语',
        'sl': '斯洛文尼亚语',
        'sv': '瑞典语',
        'zh': '中文',
        'he': '希伯来语',
        'ar': '阿拉伯语',
      },

      'hu': {
        'title': 'Nyelvválasztás',
        'languageSwitchDesktop': 'A nyelvválasztás bármikor módosítható, akár később is, a bal alsó sarokban',
        'languageSwitchMobile': 'A nyelvválasztás bármikor módosítható, akár később is, a menüben (kattintson a jobb felső sarokba a megnyitáshoz).',
        'confirmLanguageSelection': 'Nyelvválasztás megerősítése',
        'cs': 'Cseh',
        'de': 'Német',
        'el': 'Görög',
        'en': 'Angol',
        'es': 'Spanyol',
        'fi': 'Finn',
        'fr': 'Francia',
        'hu': 'Magyar',
        'it': 'Olasz',
        'ja': 'Japán',
        'nl': 'Holland',
        'pl': 'Lengyel',
        'pt': 'Portugál',
        'ro': 'Román',
        'ru': 'Orosz',
        'sk': 'Szlovák',
        'sl': 'Szlovén',
        'sv': 'Svéd',
        'zh': 'Kínai',
        'he': 'Héber',
        'ar': 'Arab',
      },
      'sk': {
        'title': 'Výber jazyka',
        'languageSwitchDesktop': 'Výber jazyka môžete zmeniť kedykoľvek, aj neskôr, v ľavom dolnom rohu',
        'languageSwitchMobile': 'Výber jazyka môžete zmeniť kedykoľvek, aj neskôr, v ponuke (kliknutím v pravom hornom rohu ho otvoríte).',
        'confirmLanguageSelection': 'Potvrdiť výber jazyka',
        'cs': 'Čeština',
        'de': 'Nemčina',
        'el': 'Gréčtina',
        'en': 'Angličtina',
        'es': 'Španielčina',
        'fi': 'Fínčina',
        'fr': 'Francúzština',
        'hu': 'Maďarčina',
        'it': 'Taliančina',
        'ja': 'Japončina',
        'nl': 'Holandčina',
        'pl': 'Poľština',
        'pt': 'Portugalčina',
        'ro': 'Rumunčina',
        'ru': 'Ruština',
        'sk': 'Slovenčina',
        'sl': 'Slovinčina',
        'sv': 'Švédčina',
        'zh': 'Čínština',
        'he': 'Hebrejčina',
        'ar': 'Arabčina',
      },
      'sl': {
        'title': 'Izbira jezika',
        'languageSwitchDesktop': 'Izbiro jezika je mogoče kadar koli spremeniti, tudi kasneje, v levem spodnjem kotu',
        'languageSwitchMobile': 'Izbiro jezika je mogoče kadar koli spremeniti, tudi kasneje, v meniju (kliknite v zgornjem desnem kotu, da ga odprete).',
        'confirmLanguageSelection': 'Potrdi izbiro jezika',
        'cs': 'Češčina',
        'de': 'Nemščina',
        'el': 'Grščina',
        'en': 'Angleščina',
        'es': 'Španščina',
        'fi': 'Finščina',
        'fr': 'Francoščina',
        'hu': 'Madžarščina',
        'it': 'Italijanščina',
        'ja': 'Japonščina',
        'nl': 'Nizozemščina',
        'pl': 'Poljščina',
        'pt': 'Portugalščina',
        'ro': 'Romunščina',
        'ru': 'Ruščina',
        'sk': 'Slovaščina',
        'sl': 'Slovenščina',
        'sv': 'Švedščina',
        'zh': 'Kitajščina',
        'he': 'Hebrejščina',
        'ar': 'Arabščina',
      },
    },
  },

};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
